// 分類列表 - tag 標籤列
'use client';

import { useSelector } from 'react-redux';
import { popState } from '@/slices/popSlice';
import TagComponent from '../layout/TagComponent'; // 標籤元件
import useHorizontalDrag from '@/hooks/useHorizontalDrag';

const CategoryTags = ({ tags }) => {
    const { showMenu } = useSelector(popState);
    const { wrapRef, mouseDownHandler, isDragging } = useHorizontalDrag(); // 處理拖拉用

    return (
        <div
            className={`noScrollX trans ${
                showMenu ? 'max-w-[calc(100vw-200px)]' : 'max-w-[calc(100vw-60px)]'
            } ulg:max-w-[unset] ulg:w-full`}
            ref={wrapRef}
            onMouseDown={(e) => mouseDownHandler(e)}
        >
            <div className="w-max px-[30px] flex items-center gap-x-[6px] ulg:px-[15px] mt-[10px] mb-[12px]">
                {tags?.map((item, i) => (
                    <TagComponent
                        key={`category-tag-list-${i}`}
                        tag={item}
                        isDragging={isDragging}
                    />
                ))}
            </div>
        </div>
    );
};

export default CategoryTags;
